import { pad } from "common/services/util"
import { findTasksByReference } from "tasks/api"

const findTaskByReferenceUseCase = reference => {
    const ref = pad(reference, 4)

    return findTasksByReference(ref).then(data => {
        const taskData = data.docs[0]
        return { id: taskData.id, ...taskData.data()}
    })
}

export default findTaskByReferenceUseCase